<template>
  <div class="user-box" v-if="user">
    <!-- 个人信息 -->
    <div class="baby-info">
      <div class="hd">
        <van-image :src="user.avatar" show-error show-loading />
      </div>
      <div class="bd">
        <div class="bd-title" @click="togglePopup">{{ user.nickname }}
          <!-- <img src="@/assets/icons/edit.png" alt=""> -->
        </div>
        <!-- <p class="bd-desc">性别：男</p>
        <p class="bd-desc">生日： 2015-10-11</p> -->
      </div>
      <div class="ft">
        <!-- <p class="ft-title">0</p>
        <p class="ft-desc">学分 <van-icon name="arrow" size="10px" /></p> -->
      </div>
    </div>
    <div class="surprise">
      <div class="title">发现惊喜</div>
      <div class="surprise_entry">
        <!-- <router-link class="item" to="">
          <img src="@/assets/images/integral_mall_entry.png" alt="">
        </router-link> -->
        <!-- <router-link class="item" to="">
          <img src="@/assets/images/app_download_entry.png" alt="">
        </router-link> -->
        <router-link class="item" to="coupon">
          <img src="@/assets/images/coupon_entry.png" alt="">
        </router-link>
        <router-link class="item" to="gift">
          <img src="@/assets/images/send_subject.png" alt="">
        </router-link>
        <!-- <router-link class="item" to="">
          <img src="@/assets/images/baby_exam_entry.png" alt="">
        </router-link> -->
      </div>
    </div>
    <!-- 自助服务 -->
    <div class="self_help">
      <div class="title">自助服务</div>
      <div class="self_help_entry">
        <router-link class="item" to="/orders">
          <img src="@/assets/icons/orders.png" alt="">
          <p class="text">我的订单</p>
        </router-link>
        <div class="item" @click="cleanCache">
          <img src="@/assets/icons/clean.png" alt="">
          <p class="text">清除缓存</p>
        </div>
      </div>
    </div>

    <!-- 个人信息编辑弹框 -->
    <van-popup class="create-popup" v-model="show" :close-on-click-overlay="false">
      <div class="popup-bd">
        <div class="upload-avatar">
          <div class="avatar" @click="imagePreview">
            <img src="@/assets/images/defalut_boy.png" alt="">
          </div>
          <div class="upload">
            <input type="file" class="avatar-upload">
            上传宝宝靓照
          </div>
        </div>
        <div class="gender">
          <div class="gender_box" :class="gender === 0 ? 'active' : ''" @click="gender = 0">
            <span></span> 小公主
          </div>
          <div class="gender_box" :class="gender === 1 ? 'active' : ''" @click="gender = 1">
            <span></span>
            小王子
          </div>
        </div>
        <div class="input">
          <span>小名:</span>
          <input type="text" v-model="user.nickname" />
        </div>
        <div class="input">
          <span>生日:</span>
          <input type="text" v-model="birthday" disabled />
        </div>
      </div>
      <div class="popup-ft">
        <van-button type="default" block hairline round @click="togglePopup">取消</van-button>
        <van-button type="warning" block round @click="save">保存</van-button>
      </div>
    </van-popup>

    <!-- 底部导航菜单 -->
    <Tabbar v-if="user" :isDistributor="user.isDistributor" />
  </div>
</template>
<script>
import Tabbar from '@/components/Tabbar'
import { ImagePreview } from 'vant'
import { removeToken } from '@/utils/auth'
import { getProfile } from './query.gql'
export default {
  name: 'my',
  data() {
    return {
      show: false,
      user: '',
      birthday: '',
      gender: 0
    }
  },
  components: {
    Tabbar
  },
  async mounted() {
    await this.weixinAuth()
    this.loadUserInfo()
  },
  methods: {
    loadUserInfo() {
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getProfile,
        fetchPolicy: 'no-cache'
      }).then(res => {
        self.user = res.data.profile
        self.$toast.clear()
        // self.$zhuge.identify(self.user.id, {
        //   name: self.user.nickname,
        //   avatar: self.user.avatar
        // })
      }).catch(err => {
        self.$toast.clear()
        console.error('page：my/index。请求getProfile报错', err)
      })
    },
    cleanCache() {
      removeToken()
      this.$toast({
        type: 'success',
        duration: 1500,
        message: '已清除缓存',
        mask: true,
        forbidClick: true,
        onClose() {
          window.location.replace(location.origin)
        }
      })
    },
    imagePreview() {
      ImagePreview({
        showIndex: false,
        images: ['https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1564917509528&di=e8cb837dba05fea49590ff8916758d3b&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201606%2F24%2F20160624125032_CvWGs.jpeg']
      })
    },
    togglePopup() {
      // this.show = !this.show
    },
    save() {
      this.show = false
    }
  }
}
</script>
<style lang="scss">
  .user-box {
    // background: #f7f4f8 url('~@/assets/images/personal_bg.png') no-repeat top / 100%;
  }
  .baby-info{
    padding: 20px 18px 21px;
    display: flex;
    align-items: center;
    .hd{
      width: 65px;
      height: 65px;
      margin-right: 15px;
      img{
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .bd{
      flex: 1;
      .bd-title{
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: bold;
        color: #333;
        padding-top: 5px;
        img{
          width: 14px;
          height: 14px;
          padding-left: 5px;
        }
      }
      .bd-desc{
        font-size: 13px;
        color: #595959;
        padding-top: 7px;
      }
    }
    .ft{
      text-align: center;
      color: #7f51ff;
      font-weight: bold;
      .ft-title{
        font-size: 27px;
        padding-bottom: 6px;
      }
      .ft-desc{
        font-size: 15px;
      }
    }
  }
  .surprise{
    padding: 0 18px 10px;
    background: #fff;
    .title{
      font-size: 19px;
      padding: 16px 0;
      font-weight: bold;
      color: #404040;
    }
    .surprise_entry{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item{
        margin-bottom: 17px;
        img{
          width: 165px;
        }
      }
    }
  }
  .self_help{
    padding: 0 18px 10px;
    background: #fff;
    margin-top: 4px;
    .title{
      font-size: 19px;
      padding: 16px 0;
      font-weight: bold;
      color: #404040;
    }
    .self_help_entry{
      display: flex;
      .item {
        margin-right: 26px;
        text-align: center;
        display: block;
        img {
          padding-bottom: 9px;
          margin: 0 auto;
          width: 38px;
          height: 38px;
        }
        .text{
          font-size: 14px;
          color: #4c4c4c;
        }
      }
    }
  }
  .create-popup.van-popup{
    width: 290px;
    height: 420px;
    border-radius: 15px;
    background: url('~@/assets/images/create_baby_info_upload.png') no-repeat;
    background-size: 100% 100%;
    .popup-bd{
      padding-top: 136.5px;
      .upload-avatar{
        width: 100%;
        height: 74px;
        position: relative;
        .avatar{
          width: 70px;
          height: 70px;
          border-radius: 50%;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          img{
            width: 100%;
            height: 100%;
          }
        }
        .upload{
          position: absolute;
          bottom: 0;
          left: 50%;
          padding: 3px 5px;
          white-space: nowrap;
          transform: translate(35px, 0);
          font-size: 11px;
          color: #0054ff;
          overflow: hidden;
          .avatar-upload{
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            opacity: 0;
          }
        }
      }
      .gender{
        display: flex;
        height: 52px;
        justify-content: center;
        align-items: center;
        .gender_box{
          font-size: 16px;
          color: #000;
          position: relative;
          display: flex;
          align-items: center;
          &:first-child{
            margin-right: 34px;
          }
          span{
            display: block;
            position: relative;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            border: 1px solid #000;
            margin-right: 6px;
          }
          &.active span:before{
            content: '';
            display: block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #000;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
      .input{
        padding-bottom: 10px;
        display: flex;
        align-items: center;
        color: #000;
        margin: 0 25px;
        span{
          font-size: 21px;
        }
        input{
          color: #ababab;
          border: 1px solid #000;
          width: 162.5px;
          height: 30px;
          line-height: 30px;
          border-radius: 4px;
          overflow: hidden;
          margin-left: 6px;
          padding: 0 10px;
          font-size: 17px;
        }
      }
    }
    .popup-ft{
      padding: 15px 25px 0;
      display: flex;
      justify-content: space-between;
      .van-button{
        height: 40px;
        line-height: 40px;
      }
      .van-button + .van-button{
        margin-left: 25px;
      }
      .van-button--default{
        color: #4f4f51;
        font-size: 18px;
        border: 1px solid #c6c6c6
      }
      .van-button--warning{
        font-size: 18px;
        background: #ff7800;
        border: none;
      }
    }
  }
</style>
